import { MSAViewer } from './msa-viewer';

/**
 * Getters for MSAViewer properties
 */
export class MSAViewerGetters {
  
  static getApiEndpoint(instance: MSAViewer): string | undefined {
    return instance._apiEndpoint;
  }
  
  static getIdentifier(instance: MSAViewer): string | undefined {
    return instance._identifier;
  }

  static getHeight(instance: MSAViewer): number {
    return instance._height;
  }

  static getWidth(instance: MSAViewer): number {
    return instance._width;
  }

  static getLabelWidth(instance: MSAViewer): number {
    return instance._labelWidth;
  }

}